import { convertUTCDate } from "../utils/convertionFunc";

export const getCurrentTime = () =>
  convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss");

export const createCartOrderDtlItem = ({
  item,
  type,
  patientId,
  user,
  cartId,
  vendorId,
}) => {
  const now = getCurrentTime();
  return {
    orderType: type,
    accountId: user.account_Id,
    orderState: "N",
    clinicId: user.clinic_Id,
    patientId,
    cartId,
    orderCode: item.code,
    orderName: item.name,
    quantity: 1,
    unitPrice: Number(parseFloat(item.price).toFixed(2)),
    amount: Number(parseFloat(item.price).toFixed(2)),
    discountAmount: 0,
    discountPercentage: 0,
    paidAmount: Number(parseFloat(item.price).toFixed(2)),
    status: 1,
    createdBy: user.patientId,
    modifiedBy: user.patientId,
    createdDate: now,
    modifiedDate: now,
    vendorId: item.vendorId,
    membershipDiscount: 0,
    drugCategory: item.drugCategory || "",
    testType: item.labCategory || "",
  };
};

export const createCartOrderHdrItem = ({
  Acc_branch,
  dtlItem,
  account,
  patientId,
  user,
  type,
}) => {
  const now = getCurrentTime();
  return {
    accountId: user.account_Id,
    amount: parseFloat(dtlItem.amount),
    cartOrderDtl: [dtlItem],
    clinicId: user.clinic_Id,
    deliveryAddress1: account?.address1 || "",
    deliveryCity: account?.city || "",
    deliveryCountry: account?.country || "",
    deliveryState: account?.state || "",
    deliveryZipCode: account?.pinCode || "",
    discountAmount: 0,
    discountPercentage: 0,
    orderType: type,
    paidAmount: parseFloat(dtlItem.paidAmount),
    patientId,
    status: 1,
    createdDate: now,
    modifiedDate: now,
    vendorId: Acc_branch.acc_Id,
    branchId: Acc_branch.bran_Id,
    labTestType: "",
    preferredDateAndTime: "",
    membershipCard: "",
    membershipCode: "",
    membershipDiscount: 0,
    membershipName: "",
    isMembershipDiscount: "N",
  };
};
